import template from './login.html';
import './login.less';

class LoginController {
    constructor($uibModal, LoginService) {
        'ngInject';
        this.$uibModal = $uibModal;
        this.LoginService = LoginService;
    }
}

export const LoginComponent = {
    name: 'mmsLogin',
    component: {
        template: template,
        controller: LoginController,
        bindings: {
            email: '<emailAddress',
            onLogin: '&'
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/pages/login/login.component.js